import { Close } from '@mui/icons-material'
import { Box, Button, Modal, Slider, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Cropper from 'react-easy-crop'
import getCroppedImg from 'utils/crop-images/get-cropped-img'
import { useStyles } from './styles'

interface ModalCropThemeProps {
  open: boolean
  onClose: () => void
  onCrop: (file: File) => void
  file: File
}

const ModalCropTheme: React.FC<ModalCropThemeProps> = ({ onClose, open, onCrop, file: fileItem }) => {
  const [imgSrc, setImgSrc] = useState('')

  const [crop, setCrop] = useState({ x: 0, y: 0 })
  const [zoom, setZoom] = useState(1)
  const [rotation, setRotation] = useState(0)
  const [aspect, setAspect] = useState(4 / 3)
  const [croppedAreaPixels, setCroppedAreaPixels] = useState<any>(null)

  const classes = useStyles()

  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    height: 730,
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: '0.35rem',
    border: 'none',
    outline: 'none',
    padding: '0.25rem',
    overflow: 'hidden',
  }

  const zoomPercentage = (value: number) => `${Math.round(value * 100)}%`

  const onCropIsComplete = (_: any, croppedAreaPixels: any) => {
    setCroppedAreaPixels(croppedAreaPixels)
  }

  const onCropImage = async () => {
    try {
      const photoURL = URL.createObjectURL(fileItem)

      const croppedImg = await getCroppedImg({
        imageSrc: photoURL,
        pixelCrop: croppedAreaPixels,
        rotation,
      })

      const { file, url } = croppedImg!

      const createdFileImage = new File([file], fileItem.name, { type: 'image/png' })

      setImgSrc(url)
      onCrop(createdFileImage)
      onClose()
    } catch (error) {
      console.log(error)
    }
  }

  const onLoadInitialImage = () => {
    setImgSrc('')

    const reader = new FileReader()

    reader.onload = () => {
      setImgSrc(reader.result as string)
    }
    reader.readAsDataURL(fileItem)
  }

  useEffect(() => {
    if (open) {
      onLoadInitialImage()
    }
  }, [open])

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
    >
      <Box sx={style}>
        <Box className={classes.header}>
          <Box className={classes.closeBtnBox}>
            <Close
              className={classes.closeBtn}
              onClick={onClose}
            />
          </Box>

          <Box className={classes.cropBox}>
            {!!imgSrc && (
              <Cropper
                image={imgSrc}
                crop={crop}
                zoom={zoom}
                rotation={rotation}
                aspect={aspect}
                onZoomChange={setZoom}
                onRotationChange={setRotation}
                onCropChange={setCrop}
                onCropComplete={onCropIsComplete}
              />
            )}
          </Box>

          <Box className={classes.body}>
            <Box>
              <Typography>Zoom: {zoomPercentage(zoom)}</Typography>
              <Slider
                valueLabelDisplay='auto'
                valueLabelFormat={zoomPercentage}
                min={1}
                max={3}
                step={0.1}
                value={zoom}
                onChange={(e, zoom) => setZoom(zoom as number)}
              />
            </Box>
            <Box>
              <Typography>Rotation: {rotation + '°'}</Typography>
              <Slider
                valueLabelDisplay='auto'
                min={0}
                max={360}
                value={rotation}
                onChange={(e, rotation) => setRotation(rotation as number)}
              />
            </Box>

            <Box>
              <Typography>Aspect ratio: </Typography>
              <Slider
                valueLabelDisplay='auto'
                min={0.1}
                max={3.0}
                step={0.01}
                value={aspect}
                onChange={(e, aspect) => setAspect(aspect as number)}
              />
            </Box>
          </Box>

          <Box className={classes.footer}>
            <Button
              variant='contained'
              type='submit'
              size='small'
              className={classes.btn}
              onClick={onCropImage}
            >
              Cortar
            </Button>

            <Button
              variant='outlined'
              type='button'
              color='anger'
              size='small'
              className={classes.btn}
              onClick={onClose}
            >
              Cancelar
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  )
}

export default ModalCropTheme
